<template>
  <div>
    <stup v-if="type_stup" :type="type_stup" />
    <view-record :token="token" :recruiter="true" />
  </div>
</template>

<script>
  import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
  import isMobile from 'ismobilejs';
  import stup from '@/components/online_interview/stup/index.vue';
  import viewRecord from '@/components/online_interview/view_record/index.vue';

  export default {
    name: 'view',

    components: {
      viewRecord,
      stup
    },

    mixins: [IEBrowserDetector, SafariBrowserDetector],

    props: {
      token: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        isMobile: isMobile.any
      };
    },

    created() {},

    computed: {
      type_stup() {
        if (this.isMobile) {
          return 'mobile';
        } else {
          return '';
        }
      }
    },

    methods: {}
  };
</script>

<style lang="scss" scoped>
  .start {
  }
</style>
